;(function($) {
  var AjaxProduct = function(element, options) {
    var defaults = {
      message: {
        load_end: '',
        error: '',
      },
      append: '', // 请求返回将要填充的 div calss / id
      topInner: 150, // 距离分页(内容底部)+px,
      success: $.noop
    };
    this.element  = element;
    this.isLoad   = true;
    this.loading  = this.loading();
    this.settings = $.extend({}, defaults, options);
    this.init();
  };
  AjaxProduct.prototype = {
    init: function() {
      var self = this, settings = this.settings, timers = null;
      $(self.element).hide();
      $(window).scroll(function() {
        var winScrollTop = $(this).scrollTop() + $(window).height();
        var loadTop = $(self.element).offset().top - settings.topInner;
        if ( winScrollTop > loadTop && self.isLoad ) {
          self.isLoad = false;
          timers = setTimeout(function() {
            self.ajax(self, settings);
          }, 300);
        }
      });
    },
    ajax: function(self, settings) {
      var pageURL = $(self.element).find('li.active').next().find('a').attr('href');
      if ( typeof pageURL == 'undefined' ) return $(self.element).before(self.load_end(settings));
      $.ajax({
        url: pageURL,
        type: 'post',
        data: {ajax_product: true},
        dataType: 'json',
        beforeSend: function() { $(self.element).before(self.loading) },
        success: function(json) {
        	settings.success.call(json);
          $('.spinner').remove();
          $(settings.append).append(json.product); // 加载产品
          $(self.element).html(json.pagination); // 重新覆盖翻页代码
          self.isLoad = true;
        }
      });
    },
    loading: function () {
      return '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
    },
    load_end: function(settings) {
      return '<div class="load-end text-center">' + settings.message.load_end  + '</div>';
    }
  }
  $.fn.ajaxProduct = function (options) {
    this.each(function(index, el) {
      new AjaxProduct(this, options);
    });
    return this;
  };
})(jQuery);